import React, { FC } from 'react';
import { DashboardForm } from '../dashboard-constants';
import { CreateDashboardModal } from './create-dashboard-modal';
import { DuplicateDashboardModal } from './duplicate-dashboard-modal';
import { EditDashboardModal } from './edit-dashboard-modal';
import { DashboardModelVariant } from './hooks';

export { EditDashboardModal } from './edit-dashboard-modal';
export { useDashboardManageModal } from './hooks';

type Props = {
  variant: DashboardModelVariant;
  onClose: () => void;
  initialValue?: DashboardForm;
  isDefault?: boolean;
  dashboardId: number;
};

export const DashboardModal: FC<Props> = ({ variant, ...rest }) => {
  return (
    <>
      <DuplicateDashboardModal
        {...rest}
        isShown={variant === DashboardModelVariant.Duplicate}
        initialValue={rest.initialValue as unknown as DashboardForm}
      />
      <EditDashboardModal
        {...rest}
        isShown={variant === DashboardModelVariant.Edit}
        initialValue={rest.initialValue as unknown as DashboardForm}
      />
      <CreateDashboardModal
        {...rest}
        isShown={variant === DashboardModelVariant.Create}
      />
    </>
  );
};

export { DashboardModelVariant };
